import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Toaster } from 'ngx-toast-notifications';
import { Observable } from 'rxjs';
import { TranslatorService } from '../helpers/getTranslationsHelper/translator.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    public authService: AuthService,
    public router: Router,
    public toaster: Toaster,
    private translatorService: TranslatorService
  ) { }

  private checkIFLoggedInRoleIsPermitted = this.authService.isLoggedInAndAdmin && this.authService.isLoggedInCustomerAdmin && this.authService.isLoggedInMunicipalPolice && this.authService.isLoggedInSimpleUser;

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (localStorage.getItem('currentUser')) {
      // logged in so return true
      return true;
    } else {
      // this.translatorService.getToasterTranslation(['You have to login first', 'Access Denied']).subscribe(res => {
      //   this.toaster.open({
      //     caption: res['Access Denied'],
      //     text: res['You have to login first'],
      //     type: 'warning'
      //   })
      // })
      this.router.navigate(['login']);
      return false;
    }
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isLoggedInAndAdmin && this.authService.isLoggedInCustomerAdmin) {
      return this.router.parseUrl('/404');
    } else {
      return true
    }
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    if (this.checkIFLoggedInRoleIsPermitted) {
      this.toaster.open({
        caption: 'Access Denied',
        text: 'You can`t view this page.',
        type: 'warning'
      })
      this.router.navigate(['login']);
      this.authService.resetAC()
      return false
    } else return true
  }
}
